<template>
  <div>
    <div><UserInfo /></div>
    <div v-if="CHANGE_USER_MENU_VISIBLE"><ChangeUser /></div>
    <div v-else />
    <div v-if="USER_INFO.status !== 'admin'"><TK /></div>
    <button
      v-else
      class="btn btn-sm btn-outline-primary shadow-none mr-1 mb-1"
      @click="go_otpravki"
    >
      отправки
    </button>
    <div v-if="USER_INFO.status === 'admin'"><UsersOnline /></div>
    <div v-else></div>
  </div>
</template>
<script>
import UserInfo from "./UserInfo";
import ChangeUser from "./ChangeUser";
import { mapGetters } from "vuex";
import UsersOnline from "./UsersOnline.vue";
import TK from "./TK.vue";
export default {
  name: "HomeContent",
  components: {
    UserInfo,
    ChangeUser,
    UsersOnline,
    TK
  },
  data: () => ({
    last_upload_file_1: null
  }),
  computed: {
    ...mapGetters(["CHANGE_USER_MENU_VISIBLE", "USER_INFO"])
  },
  methods: {
    go_otpravki() {
      this.$router.push("TK");
    }
  }
};
</script>
